// extracted by mini-css-extract-plugin
module.exports = {"contactLi":"ContactListItem_contactLi__CgYuJ","contactLiP":"ContactListItem_contactLiP__CjtWf","contactLiBtn":"ContactListItem_contactLiBtn__rxz_k"};